class AMCFundDataRender {
    constructor(containerElement) {
        this.$container = $(containerElement);
        this.dataSize = 0;
    }

    isMRF() {
        return this.$container.attr("category") === "MRF";
    }

    setSize(newSize) {
        this.dataSize = newSize;
    }

    updateFundRow(fundCode, fundData, MergeDataCommon, getFundTypeCallback) {
        const $row = this.$container.find(`#fund-${fundCode}`);
        const $rowMobile = this.$container.find(`#fund-mobile-${fundCode}`);

        if ($row.length > 0) {
            // Update desktop row
            const $head = $row.find(".fund-item__info");
            const $nav = $row.find(".fund-item__nav-info");
            const $dailyPerf = $row.find(".fund-item__daily-performance");
            const $accumulated = $row.find(".fund-item__accumulated-info");
            const $sixMonthPerf = $row.find(".fund-item__six-month-performance");
            const $oneYearPerf = $row.find(".fund-item__one-year-performance");
            const $fundType = $row.find(".fund-item__fund-type");

            $head.find(".fund-item__name").text(MergeDataCommon.formatString(fundData.fundName[1].shortName));

            // Handle NAV
            if (fundData.nav) {
                $nav.find(".fund-nav").text(MergeDataCommon.formatNumber(fundData.nav, fundData.navDecimalPlace, ""));
                $nav.find(".price-date").text(fundData.priceDate);
            } else {
                if (this.isMRF()) {
                    $nav.empty().html("<div>-</div>");
                } else {
                    $nav.empty().html('<div class="text-center">-</div>');
                }
            }

            // Handle daily performance (changeInPer)
            if (fundData.changeInPer !== null && fundData.changeInPer !== undefined) {
                const changeInPerData = MergeDataCommon.formatFundData(fundData.changeInPer);
                $dailyPerf.find(".number").text(changeInPerData.data).addClass(changeInPerData.color);
            } else {
                $dailyPerf.empty().html('<div class="text-center">-</div>');
            }

            // Handle accumulated price
            if (fundData.accumulatedPrice) {
                $accumulated
                    .find(".accumulated-price")
                    .text(
                        MergeDataCommon.formatNumber(
                            fundData.accumulatedPrice,
                            fundData.accumulatedPriceDecimalPlace,
                            "",
                        ),
                    );
                $accumulated
                    .find(".accumulated-price-date")
                    .text(fundData.accumulatedPriceDate ? fundData.accumulatedPriceDate : "");
            } else {
                $accumulated.empty().html('<div class="text-center">-</div>');
            }

            // Handle 6-month performance
            if (fundData.cumulativeReturnM6 !== null && fundData.cumulativeReturnM6 !== undefined) {
                const sixMonthData = MergeDataCommon.formatFundData(fundData.cumulativeReturnM6);
                $sixMonthPerf.find(".number").text(sixMonthData.data).addClass(sixMonthData.color);
                $sixMonthPerf.find(".return-date").text(fundData.asat ? fundData.asat : "");
            } else {
                $sixMonthPerf.empty().html('<div class="text-center">-</div>');
            }

            // Handle 1-year performance
            if (fundData.cumulativeReturnY1 !== null && fundData.cumulativeReturnY1 !== undefined) {
                const oneYearData = MergeDataCommon.formatFundData(fundData.cumulativeReturnY1);
                $oneYearPerf.find(".number").text(oneYearData.data).addClass(oneYearData.color);
                $oneYearPerf.find(".return-date").text(fundData.asat ? fundData.asat : "");
            } else {
                $oneYearPerf.empty().html('<div class="text-center">-</div>');
            }

            $fundType.text(getFundTypeCallback(fundData));
            $row.show();
        }

        if ($rowMobile.length > 0) {
            // Update mobile row
            const $head = $rowMobile.find(".fund-item__name");
            const $nav = $rowMobile.find(".nav-price-date");
            const $dailyPerf = $rowMobile.find(".daily-performance");
            const $accumulated = $rowMobile.find(".fund-item__invest");
            const $sixMonthPerf = $rowMobile.find(".fund-item__six-month-perf");
            const $oneYearPerf = $rowMobile.find(".fund-item__one-year-perf");
            const $fundType = $rowMobile.find(".fund-assert-class b");

            $head.text(MergeDataCommon.formatString(fundData.fundName[1].shortName));

            // Handle NAV
            if (fundData.nav) {
                $nav.find("b").text(MergeDataCommon.formatNumber(fundData.nav, fundData.navDecimalPlace, ""));
                $nav.find(".price-date").text(fundData.priceDate ? ` (${fundData.priceDate})` : "");
            } else {
                $nav.find("b").text("-");
                $nav.find(".price-date").text("");
            }

            // Handle daily performance (changeInPer)
            if (fundData.changeInPer !== null && fundData.changeInPer !== undefined) {
                const changeInPerDataM = MergeDataCommon.formatFundData(fundData.changeInPer);
                $dailyPerf
                    .find(".number b")
                    .text(changeInPerDataM.data)
                    .parent()
                    .attr("class", `number ${changeInPerDataM.color}`);
            } else {
                $dailyPerf.find(".number b").text("-");
            }

            // Handle accumulated price
            if (fundData.accumulatedPrice) {
                $accumulated
                    .find(".number b")
                    .text(
                        MergeDataCommon.formatNumber(
                            fundData.accumulatedPrice,
                            fundData.accumulatedPriceDecimalPlace,
                            "",
                        ),
                    );
                $accumulated
                    .find(".accumulated-price-date")
                    .text(fundData.accumulatedPriceDate ? `(${fundData.accumulatedPriceDate})` : "");
            } else {
                $accumulated.find(".number b").text("-");
                $accumulated.find(".accumulated-price-date").text("");
            }

            // Handle 6-month performance
            if (fundData.cumulativeReturnM6 !== null && fundData.cumulativeReturnM6 !== undefined) {
                const sixMonthDataM = MergeDataCommon.formatFundData(fundData.cumulativeReturnM6);
                $sixMonthPerf.find(".number b").text(sixMonthDataM.data).parent().addClass(sixMonthDataM.color);
                $sixMonthPerf.find(".return-date").text(fundData.asat ? `(${fundData.asat})` : "");
            } else {
                $sixMonthPerf.find(".number b").text("-");
                $sixMonthPerf.find(".return-date").text("");
            }

            // Handle 1-year performance
            if (fundData.cumulativeReturnY1 !== null && fundData.cumulativeReturnY1 !== undefined) {
                const oneYearDataM = MergeDataCommon.formatFundData(fundData.cumulativeReturnY1);
                $oneYearPerf.find(".number b").text(oneYearDataM.data).parent().addClass(oneYearDataM.color);
                $oneYearPerf.find(".return-date").text(fundData.asat ? `(${fundData.asat})` : "");
            } else {
                $oneYearPerf.find(".number b").text("-");
                $oneYearPerf.find(".return-date").text("");
            }

            $fundType.text(getFundTypeCallback(fundData));
            $rowMobile.show();
        }

        return $row;
    }

    renderTemplate(fundSet) {
        const $allRows = this.$container.find(".fund-item");

        // First, hide all rows
        $allRows.hide();

        // Track which fund codes have data
        const fundCodesWithData = new Set();

        // Get the table body and mobile container for reordering
        const $desktopTbody = this.$container.find(".fund-data-list-desktop");
        const $mobileContainer = this.$container.find(".camc-fund-list__container--mobile");

        // Get the no result message elements
        const $noResultDesktop = this.$container.find(".fund-info-no-result");
        const $noResultMobile = this.$container.find(".fund-info-no-result--mobile");

        // Show/hide no result message based on fundSet
        if (!fundSet || fundSet.size === 0) {
            $noResultDesktop.show();
            $noResultMobile.show();
        } else {
            $noResultDesktop.hide();
            $noResultMobile.hide();
        }

        if (fundSet && fundSet.size != 0) {
            // Show and reorder rows based on fundSet order
            [...fundSet].forEach((item, index) => {
                fundCodesWithData.add(item.fundCode);

                const $desktopRow = this.$container.find(`#fund-${item.fundCode}`);
                const $mobileRow = this.$container.find(`#fund-mobile-${item.fundCode}`);

                // Reorder by appending to container (moves element to end, maintaining sort order)
                if ($desktopRow.length > 0) {
                    $desktopTbody.append($desktopRow);
                    $desktopRow.show();
                }
                if ($mobileRow.length > 0) {
                    $mobileContainer.append($mobileRow);
                    // Mark first visible item with class, remove from others
                    if (index === 0) {
                        $mobileRow.addClass("first-visible");
                    } else {
                        $mobileRow.removeClass("first-visible");
                    }
                    $mobileRow.show();
                }

                // Set active state for first mobile item
                if (index === 0) {
                    $mobileRow.find(".fund-item__title").addClass("is-active");
                    $mobileRow.find(".fund-item__content").css("max-height", "450px");
                } else {
                    $mobileRow.find(".fund-item__title").removeClass("is-active");
                    $mobileRow.find(".fund-item__content").css("max-height", "");
                }
            });
        }

        // Hide desktop rows without data (don't remove, just hide for re-filtering)
        this.$container.find(".fund-data-list-desktop .fund-item").each(function () {
            const fundCode = $(this).attr("id").replace("fund-", "");
            if (!fundCodesWithData.has(fundCode)) {
                $(this).hide();
            }
        });

        // Hide mobile rows without data (don't remove, just hide for re-filtering)
        this.$container.find(".camc-fund-list__container--mobile .fund-item").each(function () {
            const fundCode = $(this).attr("id").replace("fund-mobile-", "");
            if (!fundCodesWithData.has(fundCode)) {
                $(this).hide();
            }
        });

        // Update fund total count
        let $fundTotal = this.$container.find(".fund-list-total");
        $fundTotal.html(`共 <b>${fundSet.size}</b><span class="text-grey-400">/${this.dataSize}</span> 只基金`);
    }
}

export default AMCFundDataRender;
